/* eslint-disable */
export enum UserDashboardSiderItem {
	DASHBOARD = 'Dashboard',

	ACCOUNT = 'Account',
	PASSWORD = 'Password',
	SETTINGS = 'Settings',
	SUBSCRIPTION = 'Subscription',
	SUBSCRIPTION_MANAGEMENT = 'Subscription',
	USAGE = 'Usage',
	CREDITS = 'Credits',
	PREFERENCES = 'Preferences',

	CONTACT_SUPPORT = 'Contact Support',
	EXPLORE_FEATURES = 'Explore Features',
	LOGOUT = 'Logout',

	RESELLER_SUPPORT_BUTTON_1 = 'Reseller Support Button 1',
	RESELLER_SUPPORT_BUTTON_2 = 'Reseller Support Button 2',
	RESELLER_PLAN = 'Plan Subscription',

	PR_STATS = 'pr-stats',

	OUTBOUND_SETTINGS = 'Outbound Settings',
	OUTBOUND_BYOT = 'Bring Your Twilio',
	OUTBOUND_EMAIL = 'Email Configuration',
}
